<!--@format-->
<template>
    <div class="recipient-statuses-widget">
        <section class="widget-header">
            <h3>Recipients</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </section>
        <section class="content-wrapper">
            <div v-if="allDoneSigners.length">
                <label class="title">Recipients who have signed</label>
                <document-recipient-status
                    v-for="recipient in allDoneSigners"
                    :key="recipient.id"
                    :recipient="recipient"
                    :is-ordered="isOrdered"
                />
            </div>
            <div v-if="missingSigners.length">
                <label class="title">Recipients who haven't signed</label>
                <document-recipient-status
                    v-for="recipient in missingSigners"
                    :key="recipient.id"
                    :recipient="recipient"
                    :is-ordered="isOrdered"
                />
            </div>
            <div v-if="otherRecipients.length">
                <label class="title">CC recipients</label>
                <document-recipient-status
                    v-for="recipient in otherRecipients"
                    :key="recipient.id"
                    :recipient="recipient"
                    :is-ordered="isOrdered"
                />
            </div>
            <p class="description">
                In order to protect the signer, you must first void the document if you wish to make
                any edits to their info. A voided document is sent back to the status of draft where
                you can make any modifications needed.
            </p>
        </section>
        <section class="widget-footer">
            <div class="actions-container">
                <app-button class="transparent-btn" @click="closeWidget"> Cancel </app-button>
            </div>
        </section>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const DocumentRecipientStatus = () => import('@/components/document/document-recipient-status.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
import EventBus from '@/scripts/event-bus';

export default {
    name: 'recipient-statuses-widget',

    components: {
        'app-button': AppButton,
        'document-recipient-status': DocumentRecipientStatus,
        'widget-close-svg': WidgetCloseSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            allDoneSigners: [],
            missingSigners: [],
            otherRecipients: [],
        };
    },

    computed: {
        isOrdered() {
            return this.widget.options.hasSigningOrder;
        },
    },

    created() {
        const recipients = this.widget.options.recipients;
        this.signerRecipients(recipients);
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        signerRecipients(recipients) {
            recipients.forEach((recipient) => {
                if (recipient.isSigner) {
                    if (recipient.hasCompletedDocument) {
                        this.allDoneSigners.push(recipient);
                    } else {
                        this.missingSigners.push(recipient);
                    }
                } else {
                    this.otherRecipients.push(recipient);
                }
            });
        },
    },
};
</script>

<style>
.recipient-statuses-widget .content-wrapper {
    display: flex;
    flex-direction: column;
    padding: 24px 35px 42px 35px;
}

.recipient-statuses-widget .content-wrapper .description {
    text-align: left;
    font: normal normal normal 14px/19px Nunito;
    letter-spacing: 0px;
    color: #382153;
    margin-top: 12px;
}

.recipient-statuses-widget .content-wrapper .title {
    margin-bottom: 18px;
}

.recipient-statuses-widget .widget-footer .app-button.normal {
    border: 1px solid #cac6cb;
    border-radius: 20px;
    background: transparent;
    color: #382153;
    height: 40px;
    width: 127px;
}
</style>
